import { configureStore } from '@reduxjs/toolkit'
import storeBlogsReducer from 'routes/blog/storeBlogsSlice'
import priceQuoteReducer from 'routes/online_quotes/priceQuoteSlice'
import onlineQuoteFormReducer from 'routes/online_quotes/content/onlineQuoteFormSlice'
import primaryFormReducer from 'components/forms/segments/primaryFormSlice'

export default configureStore({
  reducer: {
    storeBlogs: storeBlogsReducer,
    priceQuote: priceQuoteReducer,
    onlineQuoteForm: onlineQuoteFormReducer,
    primaryForm: primaryFormReducer,
  },
})